import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { SafeHtml, DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Params } from '@angular/router';
import { APIConfigMapping, APP_BUILDER_PERMISSIONS, HTTPAPIConfig, PERMISSIONS_ACTIONS, VlDataService, VlHttpService } from 'shared-library';
import { SharedService } from '../../Services/shared.service';
import { Clipboard } from '@angular/cdk/clipboard';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'lib-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrl: './privacy-policy.component.scss'
})
export class PrivacyPolicyComponent implements OnInit,OnDestroy{

  @ViewChild('policyTemplate') public policyTemplate!: TemplateRef<any>;
  @ViewChild('resetPolicyTemplate') public resetPolicyTemplate!: TemplateRef<any>;
  content: string = "";
  sanitizedContent: SafeHtml = '';
  queryParams:any = {};
  policyId!:string | null;
  logo:string = "";
  spinnerActive:boolean = false;
  policyURL:string = '';
  saved:boolean = false;
  destroy$ = new Subject<void>();

  appPermissions = APP_BUILDER_PERMISSIONS;
  permissionsActions = PERMISSIONS_ACTIONS;

  // commented some options to enable in a futere version.
  quillConfig = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
      ['blockquote'],
      ['link'],
      [{ 'header': 1 }, { 'header': 2 }],               // custom button values
      [{ 'list': 'ordered'}, { 'list': 'bullet' },],
      // [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
      [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
      [{ 'direction': 'rtl' }],                         // text direction
      [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
      // [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
      // [{ 'font': [] }],
      [{ 'align': [] }],
    
      ['clean']                     ]
  };
  

  constructor(private sanitizer: DomSanitizer, private dataService: VlDataService,private clipboard:Clipboard, public dialog: MatDialog,
    private httpService: VlHttpService, private route: ActivatedRoute,private sharedService:SharedService,private toastr:ToastrService) {
     
    }

    ngOnInit(): void {
      this.subscribeRouterEvents();
      this.getPolicy();
    }

    subscribeRouterEvents(){
      this.route.queryParams.pipe(takeUntil(this.destroy$)).subscribe((params: Params) => {
        this.queryParams = {};
        for (const param in params) {
          if (params.hasOwnProperty(param)) {
            this.queryParams[param] = params[param];
          }
        }
        
      });
    }

    getPolicy(){
      const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['PRIVACY_POLICY_GET']);
        apiConfig.postData = {
          applicationId:this.queryParams['id']
        }
  
      this.httpService.placeAPICall(apiConfig).pipe(takeUntil(this.destroy$)).subscribe({
        next: (data: any) => {
          this.policyId = data?.policyId ?? null;
          if(data.content){
            this.content = data.content;
          }
          this.logo = data?.logo ?? "";
          this.policyURL = data?.url ?? '';
        },
        error: (err: any) => {
          if(err?.status == 403) {
            this.toastr.error('You do not have permission to access this resource.');
          }else{
            this.toastr.error('Failed to retrieve the policy. Please try again later.');
          }
          this.content = "";
        }
      })
    }

    saveContent() {
      this.sanitizedContent = this.sanitizer.bypassSecurityTrustHtml(this.content);
      const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['PRIVACY_POLICY_ADD_OR_EDIT']);
      apiConfig.postData = {
        policy:this.content ?? '',
        logo:this.sharedService.getApplicationDataEntire()['image'],
        applicationId:this.queryParams['id']
      }
      if(this.policyId){
        apiConfig.postData['policyId'] = this.policyId;
      }
  
      this.httpService.placeAPICall(apiConfig).pipe(takeUntil(this.destroy$)).subscribe({
        next: (data: any) => {
          this.policyURL = data['url'] ?? '';
          this.saved = true;  
          this.policyId = data['policyId'];
          this.openDialog();

        },
        error: (err: any) => {
          if(err?.status == 403) {
            this.toastr.error('You do not have permission to access this resource.');
          }else{
            this.toastr.error('Failed to save the policy. Please try again later.')
          }
        }
      })
    }

    resetPolicy(){
      const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['RESET_PRIVACY_POLICY']);
      apiConfig.postData = {
        applicationId:this.queryParams['id']
      }
      if(this.policyId){
        apiConfig.postData['policyId'] = this.policyId;
      }
  
      this.httpService.placeAPICall(apiConfig).pipe(takeUntil(this.destroy$)).subscribe({
        next: (data: any) => {
          this.policyURL = data['url'] ?? '';
          this.saved = true;  
          this.policyId = data['policyId'];
          this.content = data["content"] ?? '';

        },
        error: (err: any) => {
          if(err?.status == 403) {
            this.toastr.error('You do not have permission to access this resource.');
          }else{
            this.toastr.error('Failed to reset the policy. Please try again later.')
          }
        }
      })
    }

    resetPolicyDialog(){
      const dialogref = this.dialog.open(this.resetPolicyTemplate);
      dialogref.afterClosed().subscribe((result: boolean) => {
        if (result) {
          this.resetPolicy();
        } 
      });
    }

  copyToClipboard(url: string) {
    this.clipboard.copy(url);
  }

  openDialog(): void {
   this.dialog.open(this.policyTemplate);
  }

  sendtoastr(message:any){
    this.toastr.success(message);
  }

  ngOnDestroy(): void {
    this.dialog.closeAll();
    this.destroy$.next();
    this.destroy$.complete();
  }

}
